'use strict';

var bind = require('function-bind');
module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);